/* eslint @typescript-eslint/no-explicit-any: 0 */

import { Index as DefaultIndex, InstantSearch } from 'react-instantsearch-dom';

import useRootData from '~/hooks/useRootData';
import { defaultAlgoliaContext } from '~/legacy/components/header/Search/Algolia';

export const useIndexName = (
  indexKey: string,
  apiKey: string,
  appId: string,
  index: string
) => {
  const { indexes }: { indexes: Record<string, string | undefined> } =
    defaultAlgoliaContext(apiKey, appId, index);

  return indexes[indexKey];
};

function makeIndex(indexKey: string) {
  const DefaultIndexGenerator = (props: any) => {
    const data = useRootData();
    const {
      env: { ALGOLIA_API_KEY, ALGOLIA_APP_ID, ALGOLIA_LEGACY_INDEX }
    } = data;

    return (
      <DefaultIndex
        indexName={useIndexName(
          indexKey,
          ALGOLIA_API_KEY,
          ALGOLIA_APP_ID,
          ALGOLIA_LEGACY_INDEX
        )}
        {...props}
      />
    );
  };

  return DefaultIndexGenerator;
}

export const Index = makeIndex('main');

const InstantSearchCustom = (props: any) => {
  const data = useRootData();
  const {
    env: { ALGOLIA_API_KEY, ALGOLIA_APP_ID, ALGOLIA_LEGACY_INDEX }
  } = data;

  const algoliaConfig = defaultAlgoliaContext(
    ALGOLIA_API_KEY,
    ALGOLIA_APP_ID,
    ALGOLIA_LEGACY_INDEX
  );

  return (
    <InstantSearch
      indexName={algoliaConfig.indexes.main || ''}
      searchClient={algoliaConfig.searchClient}
      {...props}
    />
  );
};

export default InstantSearchCustom;
